import {Component, TemplateRef} from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PanelConfigurationNonWorkingDay } from '../../model/configuration/panelConfigurationNonWorkingDay.model';
import { PanelConfigurationNonWorkingDayResult } from '../../model/configuration/panelConfigurationNonWorkingDayResult.model';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {GenericModalService} from '../../services/utils/generic-modal.service';

@Component({
  selector: 'app-non-working-days',
  templateUrl: './non-working-days.component.html',
  styleUrls: ['./non-working-days.component.css']
})
export class NonWorkingDaysComponent {

  panelConfigurationNonWorkingDay: PanelConfigurationNonWorkingDay;
  panelConfigurationNonWorkingDayList: Array<PanelConfigurationNonWorkingDay>;
  isEditMode: boolean;
  isSaving: boolean;
  successfullySaved: boolean;
  isConfigLoading: boolean;
  bsValue = new Date();


  constructor(private modalService: BsModalService,
              private fb: FormBuilder,
              private configurationService: ConfigurationService,
              private toastr: ToastrService,
              private localeService: BsLocaleService,
              public bsModalRef: BsModalRef,
              public genericModalService: GenericModalService) {

    this.isConfigLoading = false;
    this.isEditMode = false;
    this.panelConfigurationNonWorkingDay = new PanelConfigurationNonWorkingDay();
    this.panelConfigurationNonWorkingDayList = new Array<PanelConfigurationNonWorkingDay>();
    this.listNonWorkingDays();
    localeService.use('pt-br');
  }

  onClickNew(staticModel: TemplateRef<any>) {
    this.panelConfigurationNonWorkingDay = new PanelConfigurationNonWorkingDay();
    this.panelConfigurationNonWorkingDay.nonWorkingDay = new Date();
    this.successfullySaved = false;
    this.isSaving = false;
    this.isEditMode = false;

    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {});
  }

  onClickEdit(content: PanelConfigurationNonWorkingDay, staticModel: TemplateRef<any>) {

    this.panelConfigurationNonWorkingDay = Object.assign({}, content);
    this.panelConfigurationNonWorkingDay.nonWorkingDay = new Date(this.panelConfigurationNonWorkingDay.nonWorkingDay);

    this.successfullySaved = false;
    this.isSaving = false;
    // this.modalRef = staticModel;
    this.isEditMode = true;
    // staticModel.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {});
  }

  onClickDelete(content: PanelConfigurationNonWorkingDay) {
    this.panelConfigurationNonWorkingDay = Object.assign({}, content);
  }

  onClickConfirmDelete() {
    this.configurationService.deleteNonWorkingDay(this.panelConfigurationNonWorkingDay.id).subscribe((resp: any) => {

      if (resp !== null && resp.error !== null && resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro'
          , { positionClass: 'toast-top-center' });
          return;
      }

      this.toastr.success(`${this.panelConfigurationNonWorkingDay.description} excluído com sucesso!`, 'Sucesso'
        , { positionClass: 'toast-top-center' });
      this.listNonWorkingDays();
    },
      (err: any) => {
        const error = err.error.message || err.statusText;
        this.toastr.error(error, 'Error'
          , { positionClass: 'toast-top-center' });

      });
  }

  isValidForm() {

    return this.panelConfigurationNonWorkingDay.nonWorkingDay && this.panelConfigurationNonWorkingDay.description;
  }

  listNonWorkingDays() {

    this.isConfigLoading = false;
    this.configurationService.listNonWorkingDays().subscribe((resp: PanelConfigurationNonWorkingDayResult) => {
      if (resp.result) {
        this.panelConfigurationNonWorkingDayList = resp.result;
      } else if (resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
      }
      this.isConfigLoading = false;
    });
  }

  onClickSaveNonWorkingDay() {

    if (!this.isValidForm()) {
      this.toastr.error('Não é possível salvar pois existe(m) campo(s) inválido(s).', 'Erro', { positionClass: 'toast-top-center' });
      return;
    }

    this.isSaving = true;
    this.configurationService.saveNonWorkingDay(this.panelConfigurationNonWorkingDay)
      .subscribe(
        (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Dia não trabalhado salvo com sucesso!', 'Sucesso', { positionClass: 'toast-top-center' });
            this.isSaving = false;
            this.onCloseModal();
            this.listNonWorkingDays();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
          }
          this.isSaving = false;
        }
      );
  }

  onCloseModal() {
    this.bsModalRef.hide();
  }

}
